import React from 'react';
import TenantModuleGate from './TenantModuleGate';

interface ProduccionModuleGateProps {
  children: React.ReactNode;
}

const ProduccionModuleGate: React.FC<ProduccionModuleGateProps> = ({ children }) => (
  <TenantModuleGate moduleKey="produccion">{children}</TenantModuleGate>
);

export default ProduccionModuleGate;
